import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
  Typography,
} from '@mui/material';
import {
  Close as CloseIcon,
  Print as PrintIcon,
} from '@mui/icons-material';

const PreviewDialog = ({ 
  open, 
  onClose, 
  htmlContent, 
  onPrint, 
  format = 'receipt',
  container, // ✅ Add this prop
  style, // ✅ Add this prop
}) => {
  // ✅ Determine dialog width based on format
  const maxWidth = format === 'a4' ? 'lg' : 'sm';
  const previewWidth = format === 'a4' ? '210mm' : '80mm';
  const previewHeight = format === 'a4' ? '297mm' : 'auto';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth} // ✅ Dynamic max width
      fullWidth
      container={container} // ✅ Add this
      disablePortal={!!container} // ✅ Add this
      style={style} // ✅ Add this
      sx={{
        position: container ? 'absolute' : undefined, // ✅ Add this
        zIndex: container ? 2000 : undefined, // ✅ Add this
      }}
      BackdropProps={{
        sx: {
          position: container ? 'absolute' : undefined, // ✅ Add this
        }
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid',
          borderColor: 'divider',
          pb: 2,
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          {format === 'a4' ? 'Preview Invoice (A4)' : 'Preview Receipt (80mm)'}
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 0, bgcolor: '#f5f5f5' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
            p: 3,
            overflowY: 'auto',
            maxHeight: 'calc(90vh - 180px)',
          }}
        >
          <Box
            sx={{
              width: previewWidth, // ✅ Dynamic width
              minHeight: previewHeight, // ✅ Dynamic height
              bgcolor: 'white',
              boxShadow: 3,
              overflow: 'hidden',
              '& iframe': {
                border: 'none',
              },
            }}
          >
            <iframe
              srcDoc={htmlContent}
              style={{
                width: '100%',
                height: format === 'a4' ? previewHeight : '100vh',
                border: 'none',
              }}
              title="Receipt Preview"
            />
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2.5, borderTop: '1px solid', borderColor: 'divider' }}>
        <Button onClick={onClose} variant="outlined" sx={{ minWidth: 100 }}>
          Close
        </Button>
        <Button
          onClick={onPrint}
          variant="contained"
          startIcon={<PrintIcon />}
          sx={{ minWidth: 120 }}
        >
          Print
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewDialog;